import {
  Button,
  Col,
  Form,
  Image,
  message,
  Popconfirm,
  Row,
  Skeleton,
  Space,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState, useEffect, useRef } from "react";
import UploadImage from "../../../midjourney/components/UploadImage";
import axios from "axios";
import {
  API_KEY_OPENAI,
  ASSET_URL_VIEW_IMAGE,
  AWS_API_UPLOAD_IMAGE,
} from "../../../../../config";
import { DeleteOutlined } from "@ant-design/icons";
import UserMessage from "../MessageItem/UserMessage";
export default function GeneratorImage() {
  const list = useRef();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const conversationGeneratorImage = localStorage.getItem(
    "conversation-generator-image",
  );
  const [conversation, setconversation] = useState(
    conversationGeneratorImage ? JSON.parse(conversationGeneratorImage) : [],
  );

  const toBottom = () => {
    const container = list.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  };

  useEffect(() => {
    localStorage.setItem(
      "conversation-generator-image",
      JSON.stringify(conversation),
    );
  }, [conversation]);

  const getSignedUrl = async (mime) => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    var signedUrl = null;
    await fetch(
      `${AWS_API_UPLOAD_IMAGE}/signedUrl?type=${mime}`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => (signedUrl = res))
      .catch((err) => console.error(err));
    return signedUrl;
  };

  const upload = async (base64) => {
    var file = await fetch(base64)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
    var signedUrl = await getSignedUrl(file.type);
    const upFile = await axios
      .put(signedUrl.url, file, {
        headers: {
          "Content-Type": file.type,
        },
      })
      .catch((err) => console.error(err));

    if (upFile.status === 200) {
      return {
        status: true,
        key: signedUrl.key,
      };
    } else {
      return {
        status: false,
      };
    }
  };

  const onFinishChatProduct = async (v) => {
    if (!v.prompt) return;
    setLoading(true);
    toBottom();
    setconversation((prev) => [
      {
        role: "user",
        content: v.prompt,
      },
      ...prev,
    ]);
    let dataRequest = {
      model: "gpt-image-1",
      prompt: v.prompt,
      n: 1,
      size: "1024x1024",
      quality: "auto",
    };

    const create = await axios.post(
      "https://api.openai.com/v1/images/generations",
      {
        ...dataRequest,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_KEY_OPENAI}`,
        },
      },
    );

    if (!create.status === 200) {
      message.error(`Error: ${await create.text()}`);
      setLoading(false);
      toBottom();
      return;
    }
    const image_base64 =
      "data:image/png;base64," + create.data.data[0].b64_json;

    const uploadFile = await upload(image_base64);

    if (!uploadFile) {
      setLoading(false);
      message.error(`Upfile error`);
      toBottom();
      return;
    }
    const url = ASSET_URL_VIEW_IMAGE + uploadFile.key;
    setconversation((prev) => [
      {
        role: "assistant",
        content: url,
      },
      ...prev,
    ]);
    setLoading(false);
    toBottom();
  };
  const onFinishFailed = () => {};
  const handleDeleteConversations = () => {
    setconversation([]);
  };

  const onReplyEdit = (v) => {
    form.setFieldsValue({
      prompt: v,
    });
  };
  return (
    <Row>
      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        <Form
          disabled={loading}
          form={form}
          layout="vertical"
          onFinish={onFinishChatProduct}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name="prompt"
            label="Prompt"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <TextArea rows={5} />
          </Form.Item>
          <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit">
              Generation
            </Button>
          </Form.Item>
        </Form>
      </Col>
      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        {conversation.length > 0 && (
          <div className="group-preview-chatgpt">
            <div className="group-preview-chatgpt__control">
              <Space>
                <Popconfirm
                  title="Are you sure delete?"
                  onConfirm={handleDeleteConversations}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="dashed"
                    className="btn-delete"
                    icon={<DeleteOutlined />}
                  >
                    Delete all conversations
                  </Button>
                </Popconfirm>
              </Space>
            </div>
            <ul className="message-group" ref={list}>
              {loading && (
                <li className="message-item-assistant">
                  <div
                    className="message-item-content"
                    style={{
                      overflow: "hidden",
                      padding: 0,
                    }}
                  >
                    <Skeleton.Image
                      style={{
                        width: 400,
                        height: 400,
                      }}
                      active={true}
                    />
                  </div>
                </li>
              )}
              {conversation.map((messageItem, index) => (
                <li className={`message-item-${messageItem.role}`} key={index}>
                  {messageItem.role === "user" && (
                    <UserMessage onReplyEdit={onReplyEdit}>
                      {messageItem.content}
                    </UserMessage>
                  )}
                  {messageItem.role === "assistant" && (
                    <div className="message-item-control-group">
                      <div
                        style={{
                          overflow: "hidden",
                          padding: 0,
                          width: 400,
                          maxWidth: "100%",
                        }}
                        className="message-item-content"
                      >
                        <Image
                          width={"100%"}
                          height={"100%"}
                          src={messageItem.content}
                        />
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Col>
    </Row>
  );
}
